<template>
  <div class="filter__wrapper">
    <mi-btn-dropdown
      :menu-offset="[0, 4]"
      class="filter__options-wrapper"
      auto-close
      :label="selectedFilter"
      dense
      flat
      icon-type
      dropdown-icon="caret-down"
    >
      <mi-list>
        <mi-list-item
          v-for="(filter) in filters"
          :key="filter.key"
          class="filter__options"
          clickable
          @click="filterWhatsNewData(filter.name)"
        >
          {{ filter.name }}
        </mi-list-item>
      </mi-list>
    </mi-btn-dropdown>
  </div>
</template>

<script>
  import MiList from '@/packages/@mi-library/MiList/MiList.vue'
  import MiListItem from '@/packages/@mi-library/MiList/MiListItem.vue'
  import { PRODUCT_AREA_FILTER } from '@/constants/whatsNew'
  import { onBeforeMount, ref } from 'vue'
  import { useWhatsNew } from '@/components/whats-new/composables/useWhatsNew'

  export default {
    name: 'FilterUpdates',
    components: { MiListItem, MiList },
    setup() {
      const filters = ref(PRODUCT_AREA_FILTER)
      const selectedFilter = ref(PRODUCT_AREA_FILTER[0].name)
      const { setFilteredWhatsNewData } = useWhatsNew()

      const filterWhatsNewData = name => {
        setFilteredWhatsNewData(name)
        selectedFilter.value = name
      }
      onBeforeMount(() => {
        filterWhatsNewData(selectedFilter.value)
      })

      return { filters, filterWhatsNewData, selectedFilter }
    }
  }
</script>

<style lang="scss" scoped>
  .filter {
    &__wrapper {
      display: flex;
      justify-content: flex-end;
    }

    &__options-wrapper {
      font-size: 16px;
      font-weight: 700;
    }
  }
</style>
